import React, { Component } from "react";
import "../allUser/style/style1.css";
import blueImg from "../allUser/images/user-1.png";
import { getUsers } from "../services/userServices";
import ReactLoading from "react-loading";
import Layout from "./components/Layout";

class AllUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      team: "Blue.OODA",
      filterData: false,
      showUsersNo: 10,
      data: [],
      items: [],
      DataisLoaded: false,
      selectedSort: "Select",
      isOpen: false,
    };
    this.closePopUpHandler = this.closePopUpHandler.bind(this);
    this.openPopUpHandler = this.openPopUpHandler.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.dataSortByTeam = this.dataSortByTeam.bind(this);
    this.pageClick = this.pageClick.bind(this);
    this.getPaginationGroup = this.getPaginationGroup.bind(this);
  }

  componentDidMount() {
    getUsers().then((json) => {
      this.setState({
        items: json,
        DataisLoaded: true,
      });
      console.log(this.state.items);
    });
  }

  getPaginationGroup() {
    let totalPage = Math.ceil(this.state.items.length / this.state.showUsersNo);
    return totalPage;
  }

  handleSearch(event) {
    let value = event.target.value.toLowerCase();
    let result = [];
    result = this.state.items.filter((users) => {
      return users.candidate_name.toLowerCase().search(value) != -1;
    });
    console.log(result);
    this.setState({ filterData: true });
    this.setState({ data: result });
  }

  dataSortByTeam(team) {
    let result = [];

    result = this.state?.items?.filter((user) => {
      return user.team_name === team;
    });
    this.setState({ filterData: true });
    this.setState({ data: result });
  }

  pageClick(e) {
    let result = [];
    const startIndex = e * this.state.showUsersNo - this.state.showUsersNo;
    const endIndex = startIndex + this.state.showUsersNo;
    result = this.state.items.slice(startIndex, endIndex);
    this.setState({ filterData: true });
    this.setState({ data: result });
    console.log(result);
  }

  openPopUpHandler() {
    this.setState({ isOpen: true });
  }

  closePopUpHandler() {
    this.setState({ isOpen: false });
  }

  render() {
    let pages = this.getPaginationGroup();
    let pageComp = [];
    const { DataisLoaded, items } = this.state;

   
    for (let index = 0; index < pages; index++) {
      pageComp.push(
        <li className="page-item" key={index}>
          <button
            className="page-link"
            onClick={() => {
              this.pageClick(index + 1);
            }}
          >
            {index + 1}
          </button>
        </li>
      );
    }
    return (
      <>
        {/* <Sidebar team={"users"} /> */}
        <section className="dashboard">
        <Layout>
        {!DataisLoaded && <div className="spin">
          <ReactLoading
            type={"spin"}
            color={"#000000"}
            height={"15%"}
            width={"15%"}
          />
        </div>}
             {DataisLoaded && <div className="main-pannel white-gradient">

              <div className="tab-content">
                <div
                  className="tab-pane active"
                  id="allteam"
                  role="tabpanel"
                >
                <h3>Users</h3>
                  <div className="row products-row">
                    <div className="col">
                      <div className="candidates-table-sec">
                        <div className="table-header p-3 pl-4 pr-4">
                          <div className="row">
                            <div className="col-md-4">
                              <p className="m-0 font-weight-600">
                                Name
                              </p>
                            </div>
                            <div className="col-md-3">
                              <p className="m-0 font-weight-600">Username</p>
                            </div>
                            <div className="col-md-3">
                              <p className="m-0 font-weight-600">Email</p>
                            </div>
                          
                          </div>
                        </div>
                        <div className="table-user-data candidates-table-list bg-white">
                          {this.state.filterData
                            ? this.state?.data?.map((item) => {
                                return (
                                  <div
                                    key={item.id}
                                    className="row table-items m-0 align-items-center py-3"
                                  >
                                    <div className="col-md-4 pl-4">
                                      <div className="d-flex name align-items-center">
                                        <div className="name-img mr-3">
                                          <img src={blueImg} alt="user" />
                                        </div>
                                        <p className="h6 gray-text m-0">
                                          {item.candidate_name}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <p className="h6 gray-text m-0">
                                        {item.job_title}
                                      </p>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="d-flex name align-items-center">
                                        <div
                                          className="team-img mr-3"
                                          //style={{ background: user.bgColor }}
                                        ></div>
                                        <p className="h6 gray-text m-0">
                                          {item.team_name}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-md-2">
                                      <a href="javascript:void(0)" className="btn btn-edit">
                                        Edit User
                                      </a>
                                    </div>
                                  </div>
                                );
                              })
                            : items?.map((item) => {
                                return (
                                  <div
                                    key={item.id}
                                    className="row table-items m-0 align-items-center py-3"
                                  >
                                    <div className="col-md-4 pl-4">
                                      <div className="d-flex name align-items-center">
                                        <div className="name-img mr-3">
                                          <img src={blueImg} alt="user" />
                                        </div>
                                        <p className="h6 gray-text m-0">
                                          {item.firstName} {item.lastName}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <p className="h6 gray-text m-0">
                                        {item.username}
                                      </p>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="d-flex name align-items-center">
                                        <div
                                          className="team-img mr-3"
                                          //style={{ background: user.bgColor }}
                                        ></div>
                                        <p className="h6 gray-text m-0">
                                          {item.email}
                                        </p>
                                      </div>
                                    </div>
                                  
                                  </div>
                                );
                              })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <nav
                  aria-label="Page navigation example"
                  className="text-center mt-3 d-flex justify-content-center"
                >
                  <ul className="pagination m-0 p-0">
                    <li className="page-item arrow-name prev">
                      <a className="page-link" href="#">
                       
                      </a>
                    </li>
                    {pageComp}
                    <li className="page-item arrow-name next">
                      <a className="page-link" href="#">
                        
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
              
              </div>}
              </Layout>
      </section>
      </>
    );
  }
}
export default AllUsers;
